// FAQ (blocks/purolabs-faq.liquid): topic tabs (click, arrow keys, Home/End; a #topic in the address opens that
// topic and links keep working) and, when asked for, one question open at a time.
class PurolabsFaq extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.tabs = [...this.querySelectorAll(':scope > .pl-faqb__tabs [role="tab"]')];
    this.panels = this.querySelector(':scope > .pl-faqb__panels');

    if (this.tabs.length) {
      const list = this.tabs[0].parentElement;
      list.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab) return;
        event.preventDefault();
        this.select(tab);
        if (tab.hash) history.replaceState(null, '', tab.hash);
      }, { signal });
      list.addEventListener('keydown', (event) => {
        const index = this.tabs.indexOf(document.activeElement);
        if (index < 0) return;
        const last = this.tabs.length - 1;
        const next = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: last }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        const tab = this.tabs[(next + this.tabs.length) % this.tabs.length];
        this.select(tab);
        tab.focus();
      }, { signal });
      this.select(this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0], false);
      this.showHash();
      window.addEventListener('hashchange', () => this.showHash(), { signal });
      this.panels.dataset.ready = 'true';
    }

    if (this.hasAttribute('data-one-open')) {
      this.addEventListener('toggle', (event) => {
        const opened = event.target;
        if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
        for (const other of this.querySelectorAll('details.pl-faqb__item[open]')) {
          if (other !== opened) other.open = false;
        }
      }, { capture: true, signal });
    }
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  // A hash can name a topic (#shipping) or anything inside one
  showHash() {
    const id = location.hash.length > 1 && decodeURIComponent(location.hash.slice(1));
    const target = id && document.getElementById(id);
    const panel = target && this.contains(target) && target.closest('.pl-faqb__panel');
    if (!panel) return;
    this.select(this.tabs.find((tab) => tab.getAttribute('aria-controls') === panel.id));
    if (target !== panel && target.matches('details')) target.open = true;
  }

  select(tab, scroll = true) {
    if (!tab) return;
    for (const other of this.tabs) {
      const selected = other === tab;
      other.setAttribute('aria-selected', String(selected));
      other.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(other.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    }
    if (scroll) tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }
}

if (!customElements.get('pl-faq')) customElements.define('pl-faq', PurolabsFaq);
